import React, { useState, useEffect } from "react";
import s from "./PagoCupones.module.css";

//services
import masiveDistributionServices from "../../../api/delivery/masiveDistribution";

//assets
import { dateFormats } from "../../../helpers/convertDate";
import Pager from "../../Shared/Pagination/Pagination";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PaymentsFilters from "./Filters";
import CreatePayment from "./create";
import { t } from "i18next";

//MaterialUi
import {
  Grid,
  Button,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import PaymentsIcon from "@mui/icons-material/Payments";
import Swal from "sweetalert2";
import useTranslationException from "../../../helpers/exceptions";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

export const PagoCupones = () => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);

  const formatDates = dateFormats();
  const { textColor } = useSelector((state) => state.local);

  const [items, setItems] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [edit, setEdit] = useState({
    create: false,
    status: false,
    item: {},
  });

  const [filters, setFilters] = useState({
    coupon: 0,
    gameId: 0,
    dateFrom: null,
    dateTo: null,
    raffle: 0,
    agencyId: 0,
  });
  const [agencySelected, setAgencySelected] = useState(null);
  const [raffleSelected, setRaffleSelected] = useState(null);
  const [gameSelected, setGameSelected] = useState(null);
  const [sort, setSort] = useState({
    field: "paymentDate",
    criteria: "DESC",
  });
  const [loadingDelete, setLoadingDelete] = useState({
    id: 0,
    status: false,
  });

  //Paginado
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalpages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const [openError, setOpenError] = useState(false);

  const getData = () => {
    setLoading(true);
    masiveDistributionServices
      .getWinnerCoupon(page, pageSize, sort, filters)
      .then((res) => {
        setItems(res.content);
        setTotalpages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  useEffect(() => {
    getData();
  }, [page, pageSize, sort, searching]);

  useEffect(() => {
    setRaffleSelected(null);
  }, [filters?.gameId]);

  useEffect(() => {
    if (raffleSelected?.id) {
      setFilters((prev) => ({
        ...prev,
        raffle: { number: raffleSelected.number, serie: raffleSelected.serie },
      }));
    }
  }, [raffleSelected]);

  useEffect(() => {
    if (agencySelected?.id) {
      setFilters((prev) => ({ ...prev, agencyId: agencySelected?.id }));
    }
  }, [agencySelected]);

  const handleCreate = () => {
    setEdit((prev) => ({
      ...prev,
      create: true,
    }));
  };

  const handleEdit = (item) => {
    console.log("ITEM: --> ", item);
    setEdit({
      create: false,
      status: true,
      item: item,
    });
  };

  const handleDelete = (item) => {
    console.log("handleDelete", item);

    setLoadingDelete({
      id: item.id,
      status: true,
    });
    Swal.fire({
      title: `Eliminar cupón ${item?.couponNumber} de ${item?.raffle ? (item?.raffle?.number ? t("drawNumber") + ":" + item?.raffle?.number : t("serie") + ":" + item?.raffle?.serie) : ""}`,
      text: t("ifYouDelete"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        masiveDistributionServices
          .deletePrizePayment(item.id)
          .then((response) => {
            console.log("error delete", response);
            setLoadingDelete({
              id: 0,
              status: false,
            });
            getData();
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("retry"),
            );
            setLoadingDelete({
              id: 0,
              status: false,
            });
          });
      } else {
        setLoadingDelete({
          id: 0,
          status: false,
        });
      }
    });
  };

  const handleNoSearch = () => {
    setSearching(0);
    setFilters({
      coupon: 0,
      gameId: 0,
      dateFrom: null,
      dateTo: null,
      raffleNumber: 0,
      agencyId: 0,
    });
    setPage(1);
    setTotalpages(1);
    setRaffleSelected(null);
    setAgencySelected(null);
    setGameSelected(null);
  };

  const handleSort = (name) => {
    setSort((prev) => ({
      criteria:
        prev.field === name
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: name,
    }));
  };

  return (
    <Grid container className={s.container}>
      {edit.status || edit.create ? (
        <CreatePayment edit={edit} setEdit={setEdit} getData={getData} />
      ) : (
        <>
          <Grid item container xs={11} className={s.header}>
            <Grid item lg={6} md={6} xs={12} className={s.titleContainer}>
              <PaymentsIcon
                sx={{ fontSize: "1.8rem", color: "primary.main" }}
              />
              <h4>{t("payments")}</h4>
              <Button
                className={s.add_btn}
                variant="contained"
                onClick={handleCreate}
              >
                {t("add")}
              </Button>
            </Grid>
            <Grid item xs={12} md={4} lg={4} className={s.filters}>
              <Button
                variant="contained"
                className={s.filterButton}
                onClick={() => setOpenModal(true)}
              >
                <TuneRoundedIcon
                  sx={{ color: "secondary.light", fontSize: "1.8rem" }}
                />
                <p>{t("filter")}</p>
              </Button>
              {searching ? (
                <Button
                  variant="contained"
                  className={s.filterButton}
                  onClick={() => handleNoSearch()}
                  sx={{ ml: 1 }}
                >
                  <p>{t("clearFilters")}</p>
                </Button>
              ) : null}
            </Grid>
          </Grid>

          {loading ? (
            <Grid item xs={11} className={s.loader}>
              <CircularProgress size={"3rem"} />
            </Grid>
          ) : items?.length ? (
            <Grid container item xs={11} className={s.data}>
              <TableContainer className={s.tableContainer}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("game.name")}
                      >
                        {`${t("game")} ${sort.field === "game.name" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("agencyNumber")}
                      >
                        {`${t("agency")} ${sort.field === "agencyNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("couponNumber")}
                      >
                        {`${t("coupon")} ${sort.field === "couponNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("paymentDate")}
                      >
                        {`${t("date")} ${sort.field === "paymentDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("raffle.number")}
                      >
                        {`${t("product")} ${sort.field === "raffle.number" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      {/* <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("edit")}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("delete")}
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items?.map((item, i) => (
                      <React.Fragment key={item.id}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.raffle?.game?.name	 || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {`${item?.payerAgency?.number}-${item?.payerAgency?.subNumber || 0}`}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.couponNumber}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {formatDates.formatDate(item?.paymentDate)}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.raffle
                              ? item?.raffle?.number
                                ? `${t("drawNumber")}: ${item?.raffle?.number}`
                                : `${t("serie")}: ${item?.raffle?.serie}`
                              : ""}
                          </TableCell>
                          {/* <TableCell
                            style={{ width: "10%" }}
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.status === "Enviado" ? (
                              <EditRoundedIcon
                                sx={{
                                  color: "grey",
                                  fontSize: "1.8rem",
                                  cursor: "not-allowed",
                                }}
                              />
                            ) : (
                              <EditRoundedIcon
                                className={s.iconbtn}
                                onClick={() => handleEdit(item)}
                                sx={{ color: "primary.dark" }}
                              />
                            )}
                          </TableCell>
                          <TableCell
                            style={{ width: "10%" }}
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.status === "Enviado" ? (
                              <DeleteForeverRoundedIcon
                                sx={{
                                  color: "grey",
                                  fontSize: "1.8rem",
                                  cursor: "not-allowed",
                                }}
                              />
                            ) : loadingDelete.status &&
                              loadingDelete.id === item.id ? (
                              <CircularProgress size={"2rem"} />
                            ) : (
                              <DeleteForeverRoundedIcon
                                className={s.iconbtn}
                                sx={{ color: "primary.dark" }}
                                onClick={() => handleDelete(item)}
                              />
                            )}
                          </TableCell> */}
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: "50px",
                }}
              >
                <Pager
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageCustom={pageCustom}
                  setPageCustom={setPageCustom}
                />
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={12} className={s.noResults}>
              {t("noResults")}
            </Grid>
          )}
        </>
      )}
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
      {openModal ? (
        <PaymentsFilters
          setPage={setPage}
          setSearching={setSearching}
          open={openModal}
          setOpen={setOpenModal}
          filters={filters}
          setFilters={setFilters}
          raffleSelected={raffleSelected}
          setRaffleSelected={setRaffleSelected}
          gameSelected={gameSelected}
          setGameSelected={setGameSelected}
          agencySelected={agencySelected}
          setAgencySelected={setAgencySelected}
        />
      ) : null}
    </Grid>
  );
};
